import { z } from 'zod';

/** Text chat message attributes. */
export const textChatMessageAttributesSchema = z.object({
  type: z.literal('text'),
});

/** Schema to validate chat message attributes. */
export const chatMessageAttributesSchema = z.discriminatedUnion('type', [textChatMessageAttributesSchema]);

/** Chat message attributes. */
export type ChatMessageAttributes = z.infer<typeof chatMessageAttributesSchema>;
